import guest from './guest'
import room from './room'
import maintenance from './maintenance'
import extracharge from './extracharge'
import checkin from './check-in'
import checkout from './check-out'
import housekeeping from './housekeeping'
import inventory from './inventory'
import report from './report'
import reservation from './reservation'
import inHouse from './in-house'
import admin from './admin'
import test from './test'
import staff from './staff'
const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import("@/views/HomeView.vue")
        
    },
    ...guest,
    ...room,
    ...maintenance,
    ...extracharge,
    ...checkin,
    ...checkout,
    ...housekeeping,
    ...inventory,
    ...inventory,
    ...inHouse,
    ...admin,
    ...test,
    ...staff,
    ...report,
    ...reservation,

]
export default routes;
